import { render, staticRenderFns } from "./roleList.vue?vue&type=template&id=d047de24&scoped=true&"
import script from "./roleList.vue?vue&type=script&lang=js&"
export * from "./roleList.vue?vue&type=script&lang=js&"
import style0 from "./roleList.vue?vue&type=style&index=0&id=d047de24&prod&lang=less&scoped=true&"
import style1 from "./roleList.vue?vue&type=style&index=1&id=d047de24&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d047de24",
  null
  
)

export default component.exports